import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: Number.MAX_VALUE,
			cacheTime: 1000 * 60 * 60 // 1h
		}
	}
});
